import {
    type ICountdownIterator,
    type ICountdownItem,
    type InitialSecondsGetter,
    type InitializedDateGetter,
    type TextSetter,
} from "../types";

export interface IVueProductCountdownRegistration {
    itemId: number | string;
    secondsGetter(): number;
    secondsSetter(s: number): void;
    textSetter?: TextSetter | undefined | null;
    getInitializedDate: InitializedDateGetter;
    getInitialSeconds: InitialSecondsGetter;
    setInitializedDate(s: Date): void;
    setInitialSeconds(s: number): void;
}

export class VueProductCountdownItem implements ICountdownItem {
    //shouldAppendToAuctionSocket: boolean = true;
    //auctionSocketId: any;
    textSetter: TextSetter | undefined | null;
    secondsGetter: () => number;
    secondsSetter: (s: number) => void;
    private _setInitialSeconds: (s: number) => void;
    private _getInitialSeconds: InitialSecondsGetter;
    private _setInitializedDate: (s: Date) => void;
    private _getInitializedDate: InitializedDateGetter;
    constructor({
        textSetter,
        secondsGetter,
        secondsSetter,
        setInitialSeconds,
        getInitialSeconds,
        setInitializedDate,
        getInitializedDate,
    }: IVueProductCountdownRegistration) {
        if (secondsGetter == null)
            throw new Error("secondsGetter can't be undefined/null");
        if (secondsSetter == null)
            throw new Error("secondsSetter can't be undefined/null");
        if (setInitialSeconds == null)
            throw new Error("setInitialSeconds can't be undefined/null");
        if (getInitialSeconds == null)
            throw new Error("getInitialSeconds can't be undefined/null");
        if (setInitializedDate == null)
            throw new Error("setInitializedDate can't be undefined/null");
        if (getInitializedDate == null)
            throw new Error("getInitializedDate can't be undefined/null");
        //this.auctionSocketId = itemId;
        this.textSetter = textSetter;
        this.secondsGetter = secondsGetter;
        this.secondsSetter = secondsSetter;
        this._setInitialSeconds = setInitialSeconds;
        this._getInitialSeconds = getInitialSeconds;
        this._setInitializedDate = setInitializedDate;
        this._getInitializedDate = getInitializedDate;
    }
    setInitialSeconds(initialSeconds: number): void {
        this._setInitialSeconds(initialSeconds);
    }
    getInitialSeconds(): number | undefined {
        return this._getInitialSeconds();
    }
    setInitializedDate(initializedDate: Date): void {
        this._setInitializedDate(initializedDate);
    }
    getInitializedDate(): Date | undefined {
        return this._getInitializedDate();
    }
    shouldShowTimeout(): boolean {
        return false;
    }
    setSecondsLeft(value: number): void {
        this.secondsSetter(value);
    }
    getSecondsLeft(): number {
        return this.secondsGetter();
    }
}

export class VueProductCountdownRegistration
    implements IVueProductCountdownRegistration
{
    itemId: number | string;
    secondsGetter: () => number;
    secondsSetter: (s: number) => void;
    textSetter: TextSetter | undefined | null;
    getInitializedDate: InitializedDateGetter;
    getInitialSeconds: InitialSecondsGetter;
    setInitializedDate: (s: Date) => void;
    setInitialSeconds: (s: number) => void;
    constructor({
        itemId,
        textSetter,
        secondsGetter,
        secondsSetter,
        getInitializedDate,
        getInitialSeconds,
        setInitializedDate,
        setInitialSeconds,
    }: IVueProductCountdownRegistration) {
        if (secondsGetter == null)
            throw new Error("secondsGetter can't be undefined/null");
        if (secondsSetter == null)
            throw new Error("secondsSetter can't be undefined/null");
        if (setInitialSeconds == null)
            throw new Error("setInitialSeconds can't be undefined/null");
        if (getInitialSeconds == null)
            throw new Error("getInitialSeconds can't be undefined/null");
        if (setInitializedDate == null)
            throw new Error("setInitializedDate can't be undefined/null");
        if (getInitializedDate == null)
            throw new Error("getInitializedDate can't be undefined/null");
        this.itemId = itemId;
        this.textSetter = textSetter;
        this.secondsGetter = secondsGetter;
        this.secondsSetter = secondsSetter;
        this.getInitializedDate = getInitializedDate;
        this.getInitialSeconds = getInitialSeconds;
        this.setInitializedDate = setInitializedDate;
        this.setInitialSeconds = setInitialSeconds;
    }
}

export class VueProductCountdownIterator implements ICountdownIterator {
    static registrations: VueProductCountdownRegistration[] = [];
    *getItems(): Generator<ICountdownItem, any, any> {
        for (const registration of VueProductCountdownIterator.registrations) {
            yield new VueProductCountdownItem({
                itemId: registration.itemId,
                secondsGetter: registration.secondsGetter,
                secondsSetter: registration.secondsSetter,
                textSetter: registration.textSetter,
                getInitializedDate: registration.getInitializedDate,
                getInitialSeconds: registration.getInitialSeconds,
                setInitializedDate: registration.setInitializedDate,
                setInitialSeconds: registration.setInitialSeconds,
            });
        }
    }
}
